import { Injectable } from '@angular/core';


import { HttpClient } from '@angular/common/http';
import { GlobalConstants } from '../Constants/global.constants';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class authService {

    constructor(private _http: HttpClient) { }

   

    authenticateUser(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'Auth/AuthenticateUser' ;
        return this._http.post(url, request);
    }

    


}